;(function(Drupal, $) {
  const init = () => {
    // init Freeze Table
    const freezeTables = document.querySelectorAll('.js-freeze-table');
    if (!freezeTables.length) return;

    freezeTables.forEach((table) => {
      const frozenRows = +table.dataset.frozenRows;
      const frozenColumns = +table.dataset.frozenColumns;

      if (!frozenRows && !frozenColumns) return;

      if (window.matchMedia('(min-width: 760px)').matches) {
        $(table).freezeTable({
          freezeHead: frozenRows > 0,
          freezeColumn: frozenColumns > 0,
          columnNum: frozenColumns > 0 ? frozenColumns : 0
        });
      }
    });
  };

  window.addEventListener('load', init);
})(Drupal, jQuery);
